import { render, staticRenderFns } from "./PazienteTerapiaListComponent.vue?vue&type=template&id=57942e9b&scoped=true"
import script from "./PazienteTerapiaListComponent.vue?vue&type=script&lang=js"
export * from "./PazienteTerapiaListComponent.vue?vue&type=script&lang=js"
import style0 from "./PazienteTerapiaListComponent.vue?vue&type=style&index=0&id=57942e9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57942e9b",
  null
  
)

export default component.exports